import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import PageShell from "@/components/PageShell";
import api from "@/lib/api";
import { formatDate, formatDateTime } from "@/lib/format";
import { Card, CardContent } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { StatusBadge } from "@/components/StatusBadge";
import { UserTag } from "@/components/UserTag";
import { NotaList } from "@/components/NotaList";
import { SupplierName } from "@/components/SupplierName";

const KINDS = { all: "Semua Jenis", nota: "Pindah Jadwal Nota", tranche: "Reschedule Termin BG", date: "Ubah Tanggal Jadwal", restructure: "Ubah / Split Pembayaran" };

export default function RescheduleHistory() {
  const navigate = useNavigate();
  const [rows, setRows] = useState([]);
  const [q, setQ] = useState("");
  const [kind, setKind] = useState("all");
  const [status, setStatus] = useState("all");
  useEffect(() => { api.get("/reschedule-history").then((r) => setRows(r.data)); }, []);

  const list = rows.filter((r) => (kind === "all" || r.kind === kind) && (status === "all" || r.status === status) &&
    (!q || [r.code, r.schedule_code, r.supplier_name, ...(r.invoice_numbers || [])].join(" ").toLowerCase().includes(q.toLowerCase())));

  return (
    <PageShell title="Riwayat Reschedule">
      <div className="flex flex-wrap gap-2">
        <Input placeholder="Cari kode, supplier, no. nota" value={q} onChange={(e) => setQ(e.target.value)} className="w-full sm:w-72" data-testid="rh-search" />
        <Select value={kind} onValueChange={setKind}><SelectTrigger className="w-full sm:w-56" data-testid="rh-kind"><SelectValue /></SelectTrigger>
          <SelectContent>{Object.entries(KINDS).map(([k, v]) => <SelectItem key={k} value={k}>{v}</SelectItem>)}</SelectContent></Select>
        <Select value={status} onValueChange={setStatus}><SelectTrigger className="w-full sm:w-44" data-testid="rh-status"><SelectValue /></SelectTrigger>
          <SelectContent><SelectItem value="all">Semua Status</SelectItem><SelectItem value="pending">Menunggu</SelectItem><SelectItem value="approved">Disetujui</SelectItem><SelectItem value="rejected">Ditolak</SelectItem></SelectContent></Select>
      </div>
      <Card><CardContent className="p-0 overflow-x-auto">
        <Table>
          <TableHeader><TableRow>
            <TableHead>Kode</TableHead><TableHead>Jenis</TableHead><TableHead>Jadwal</TableHead><TableHead>Supplier</TableHead>
            <TableHead>Detail</TableHead><TableHead>Tgl Lama → Baru</TableHead><TableHead>Pemohon</TableHead><TableHead>Status</TableHead><TableHead>Disetujui Oleh</TableHead>
          </TableRow></TableHeader>
          <TableBody>
            {list.map((r) => (
              <TableRow key={r.id} className="cursor-pointer" onClick={() => navigate(`/slip/${r.schedule_id}`)} data-testid={`rh-row-${r.code}`}>
                <TableCell><div className="font-semibold">{r.code}</div><div className="text-[11px] text-slate-400">{formatDateTime(r.requested_at)}</div></TableCell>
                <TableCell className="text-xs" data-testid={`rh-kind-${r.code}`}>{r.kind_label}</TableCell>
                <TableCell className="text-xs">{r.schedule_code}{r.new_schedule_code ? ` → ${r.new_schedule_code}` : ""}</TableCell>
                <TableCell><SupplierName name={r.supplier_name} /></TableCell>
                <TableCell className="text-xs max-w-[280px]"><div className="font-medium text-slate-700" data-testid={`rh-detail-${r.code}`}>{r.detail}</div><div className="mt-1"><NotaList numbers={r.invoice_numbers || []} amounts={r.invoice_amounts || []} testid={`rh-notas-${r.code}`} /></div>{r.reason && <div className="text-slate-500 italic">"{r.reason}"</div>}</TableCell>
                <TableCell className="text-xs whitespace-nowrap">{formatDate(r.old_date)} → <b>{formatDate(r.new_date)}</b></TableCell>
                <TableCell><UserTag id={r.requester_id} name={r.requester} /></TableCell>
                <TableCell><StatusBadge status={r.status} />{r.auto_note && <div className="text-[11px] text-slate-400 mt-1" data-testid={`rh-auto-note-${r.code}`}>{r.auto_note}</div>}</TableCell>
                <TableCell>{r.approver ? <UserTag id={r.approver_id} name={r.approver} /> : "-"}</TableCell>
              </TableRow>
            ))}
            {list.length === 0 && <TableRow><TableCell colSpan={9} className="text-center text-slate-400 py-8">Belum ada riwayat reschedule.</TableCell></TableRow>}
          </TableBody>
        </Table>
      </CardContent></Card>
    </PageShell>
  );
}
